import React from "react";

function LinkdinIcon() {
  return (
    <span className="anticon ant-facebook">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 12 24"
      >
        <g fill="none" fillRule="evenodd">
          <g fill="#0096dc" fillRule="nonzero">
            <g>
              <g>
                <g>
                  <path
                    d="M12.7 5.332c3.543 0 4.196 2.335 4.196 5.367v6.196h-.004v.001h-3.496v-5.629c-.004-1.285-.088-2.85-1.82-2.85-1.822 0-2.1 1.422-2.1 2.893v5.585h-3.5V5.615h3.36v1.538h.05c.466-.886 1.61-1.82 3.313-1.82zm-8.918.284v11.28H.279V5.616h3.503zM2.029 0c1.12 0 2.028.909 2.029 2.029 0 1.12-.909 2.048-2.03 2.048C.909 4.077 0 3.149 0 2.029S.909 0 2.029 0z"
                    transform="translate(-912 -1024) translate(889 711) translate(20 189) translate(3 124)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}

export default LinkdinIcon;
